import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { CoinProvider } from './context/CoinContext';
import './registerSW';

// Hide loading screen when React renders
function hideLoadingScreen() {
  const loading = document.getElementById('loading');
  if (loading) {
    loading.style.opacity = '0';
    loading.style.transition = 'opacity 0.5s ease-out';
    setTimeout(() => {
      loading.style.display = 'none';
    }, 500);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CoinProvider>
        <App />
      </CoinProvider>
    </AuthProvider>
  </React.StrictMode>
);

// Hide loading screen after React renders
// ใช้ setTimeout เพื่อให้แน่ใจว่า React render เสร็จแล้ว
setTimeout(() => {
  hideLoadingScreen();
}, 100);

// Fallback: ซ่อน loading screen หลังจาก 5 วินาที (กรณี React ไม่ render)
setTimeout(() => {
  hideLoadingScreen();
}, 5000);